var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cancelled",
    clipPath: "url(#clip0_1247_7046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close_circle_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 1C11.8661 1 15 4.1339 15 8C15 11.8661 11.8661 15 8 15C4.1339 15 1 11.8661 1 8C1 4.1339 4.1339 1 8 1ZM6.5153 5.5248C6.38962 5.39792 6.2202 5.32388 6.04172 5.31782C5.86323 5.31177 5.68918 5.37416 5.55519 5.49223C5.4212 5.61029 5.33741 5.77511 5.32096 5.95294C5.30451 6.13076 5.35664 6.30816 5.4667 6.4488L5.5255 6.5153L7.0095 7.9993L5.5255 9.4847C5.39862 9.61038 5.32458 9.7798 5.31852 9.95828C5.31247 10.1368 5.37486 10.3108 5.49293 10.4448C5.61099 10.5788 5.77581 10.6626 5.95364 10.679C6.13146 10.6955 6.30886 10.6434 6.4495 10.5333L6.5153 10.4752L8 8.9898L9.4847 10.4752C9.61038 10.6021 9.7798 10.6761 9.95828 10.6822C10.1368 10.6882 10.3108 10.6258 10.4448 10.5078C10.5788 10.3897 10.6626 10.2249 10.679 10.0471C10.6955 9.86924 10.6434 9.69184 10.5333 9.5512L10.4752 9.4847L8.9898 8L10.4752 6.5153C10.6021 6.38962 10.6761 6.2202 10.6822 6.04172C10.6882 5.86323 10.6258 5.68918 10.5078 5.55519C10.3897 5.4212 10.2249 5.33741 10.0471 5.32096C9.86924 5.30451 9.69184 5.35664 9.5512 5.4667L9.4847 5.5248L8 7.0102L6.5153 5.5248Z",
    fill: "#FFA7A1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1247_7046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.e1320c90236b91e87f2e6445f964a7d0.svg";
export { ForwardRef as ReactComponent };